import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  BannerItem,
  BannerService,
  BannerTypeData,
  CreateBannerDto
} from 'app/services/banner/banner.service';
import { ImageFallbackDirective } from '../../directives/ImageFallbackDirective';
import { PagedResult } from 'app/models/order';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppConfigService } from 'app/services/app-config.service';
import { ImageUrlPipe } from '../../pipe/image-url.pipe';
import { GalleryPickerComponent } from 'app/shared/gallery-picker/gallery-picker.component';
import { ImageItem } from 'app/services/gallery/gallery.service';

interface Language {
  code: string;
  flag: string;
}

@Component({
  standalone: true,
  selector: 'app-banners-management',
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ImageFallbackDirective,
    ImageUrlPipe,
    GalleryPickerComponent
  ],
  templateUrl: './banners-management.component.html',
  styleUrls: ['./banners-management.component.scss']
})
export class BannersManagementComponent implements OnInit {
  items: BannerTypeData[] = [];
  showModal = false;
  showDeleteConfirm = false;
  saving = false;
  loading = false;

  editingItem: BannerItem | null = null;
  deletingItem: BannerItem | null = null;
imagePreview: string | null = null;
imagePreviews: string[] = [];
selectedImageIds: number[] = [];
  types : string[] = []
  selected_type : string = ''

  showGalleryModal = false;
  selectedPhotos: ImageItem[] = [];

  bannerNumber = 1;
  selectedLanguage = 'en';

  currentPage = 1;
  pageSize = 8;
  totalCount = 0;
  totalPages = 0;

  languages: Language[] = [
    { code: 'en', flag: '🇺🇸' },
    { code: 'ar', flag: 'العربية' }
  ];

  form: CreateBannerDto = this.emptyForm();

  imageUrl : string = ''
  constructor(private bannerService: BannerService ,
    private appConfig : AppConfigService
  ) {
    this.imageUrl = appConfig.imageUrl;
    if (this.imageUrl == '') {
      this.imageUrl = appConfig.SavedURL;
    }
    this.imageUrl += "/";
  }

  private emptyForm(): CreateBannerDto {
    return {
      title: '',
      type: '',
      link: '',
      imageFile: undefined,
      sortOrder: 0,
      isActive: true
    };
  }

  ngOnInit(): void {
    this.loadTypes();
    this.loadItems();
  }




  loadItems(): void {
    this.loading = true;

    this.bannerService.getBanners(this.currentPage, this.pageSize).subscribe({
      next: (res : PagedResult<BannerTypeData>) => {
        console.log(res);
        this.items = res.data ?? [];
        this.currentPage = res.page;
        this.pageSize = res.page_size ?? 0;
        this.totalCount = res.total_count ?? 0;
        this.totalPages = res.total_pages ?? 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading banners:', err);
        this.items = [];
        this.loading = false;
      }
    });
  }
  loadTypes(): void {
    this.loading = true;

    this.bannerService.getTypes().subscribe({
      next: (res : string[]) => {
        console.log(res);
        this.types = res ?? [];
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading types:', err);
        this.types = [];
        this.loading = false;
      }
    });
  }
  onItemsPerPageChange(event: any) {
    const value = parseInt(event.target.value, 10);

    if (value > 0) {
      this.pageSize = value;
      this.currentPage = 1;
      this.loadItems();
    }
  }
  onLanguageChange(): void {
    this.form.languageCode = this.selectedLanguage;
    this.currentPage = 1;
    this.loadItems();
  }

  openModal(id? : number,banner?: BannerTypeData): void {
    let item = banner?.banners?.find(b=>b.id == id);
    this.editingItem = item ?? null;
    if(this.editingItem != null)
    {
      this.editingItem.type = banner?.type;
    }
    console.log(this.editingItem);

    if (item) {
      this.form = {
        title: item.title ?? '',
        type: banner?.type + "-" + banner?.lang,
        link: item.link ?? item.url ?? '',
        languageCode: this.selectedLanguage,
        imageFile: undefined,
        sortOrder: item.sortOrder ?? 0,
        isActive: item.isActive ?? true
      };

        this.imagePreview = item.photo ?? null;
        this.imagePreviews = item.photo ? [item.photo] : [];
        this.selectedImageIds = [];

    } else {
      this.form = this.emptyForm();
      this.imagePreview = null;
      this.imagePreviews = [];
      this.selectedImageIds = [];
      this.selectedPhotos = [];    
    }

    this.showModal = true;
  }

closeModal(): void {
  this.showModal = false;
  this.editingItem = null;
  this.imagePreview = null;
  this.imagePreviews = [];
  this.selectedImageIds = [];
  this.selectedPhotos = [];
  this.form = this.emptyForm();
}

// onImageSelected(event: Event): void {
//   const file = (event.target as HTMLInputElement).files?.[0];
//   if (!file) return;

//   this.form.imageFile = file;

//   this.selectedPhotos = [];
//   this.selectedImageIds = [];
//   this.imagePreviews = [];

//   (this.form as any).imageIds = null;
//   (this.form as any).photos = null;
//   (this.form as any).photo = null;

//   const reader = new FileReader();
//   reader.onload = (e) => {
//     this.imagePreview = e.target?.result as string;
//     this.imagePreviews = [this.imagePreview];
//   };
//   reader.readAsDataURL(file);
// }
onImageSelected(event: Event): void {
  // Disabled because API now expects image IDs from gallery, not uploaded files
  const input = event.target as HTMLInputElement;
  input.value = '';
}
removeImage(index?: number): void {
  if (index !== undefined) {
    this.imagePreviews.splice(index, 1);
    this.selectedPhotos.splice(index, 1);
    this.selectedImageIds.splice(index, 1);
  } else {
    this.imagePreviews = [];
    this.selectedPhotos = [];
    this.selectedImageIds = [];
  }

  this.imagePreview = this.imagePreviews[0] ?? null;
  this.form.imageFile = undefined;

  (this.form as any).imageIds = this.selectedImageIds;
  (this.form as any).photos = this.selectedImageIds;
  (this.form as any).photo = this.selectedImageIds.join(',');
}

saveItem(): void {
  console.log("entered");

  this.form.languageCode = this.selectedLanguage;

  if (this.form.type == '') {
    this.form.type = this.selected_type;
  } else {
    this.selected_type = this.form.type ?? '';
  }

  // مهم: تجهيز الصور للـ API
  if (this.selectedImageIds && this.selectedImageIds.length > 0) {
    (this.form as any).imageFile = this.selectedImageIds.map(id => id.toString());
  }

  this.saving = true;

  console.log(this.form);

  const request$ = this.editingItem
    ? this.bannerService.updateBanner(this.editingItem.id, this.form)
    : this.bannerService.createBanner(this.form);

  request$.subscribe({
    next: () => {
      this.saving = false;
      this.closeModal();
      this.currentPage = 1;
      this.loadItems();
    },
    error: (err) => {
      console.error('Error saving banner:', err);
      this.saving = false;
    }
  });
}
group : any ;
  confirmDelete(item: BannerItem,group:any): void {
    this.deletingItem = item;
    console.log(group);
    this.group = group;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.deletingItem = null;
    this.showDeleteConfirm = false;
  }

  deleteItem(): void {
    if (!this.deletingItem) return;
    console.log(this.deletingItem);
    console.log(this.bannerNumber);
    console.log(this.group);
    this.bannerService
      .deleteBanner(this.group.type, this.deletingItem.id, this.group?.lang)
      .subscribe({
        next: () => {
          this.deletingItem = null;
          this.showDeleteConfirm = false;

          if (this.items.length === 1 && this.currentPage > 1) {
            this.currentPage--;
          }

          this.loadItems();
        },
        error: (err) => {
          console.error('Error deleting banner:', err);
        }
      });
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.currentPage) return;
    this.currentPage = page;
    this.loadItems();
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadItems();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadItems();
    }
  }

  onPageSizeChange(size: number): void {
    this.pageSize = +size;
    this.currentPage = 1;
    this.loadItems();
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }


openGalleryModal(): void {
  this.showGalleryModal = true;
}

closeGalleryModal(): void {
  this.showGalleryModal = false;
}

onGalleryImagesChange(images: ImageItem[]): void {
  this.selectedPhotos = images;

  this.selectedImageIds = images.map(x => Number(x.id));

  this.form.imageFile =
      this.selectedImageIds.map(x => x.toString());

  this.imagePreviews =
      images.map(x => x.url);
}



}